import Filter from '@modules/serp/sidebar/search/job-type-filters'
import { useSearchStore } from '@stores/search.store'

import { JobSearch } from '@types'

import ReactModal from 'react-modal'
import { useShallow } from 'zustand/react/shallow'

import Button from '@components/buttons/button'
import CloseButton from '@components/buttons/close-button'
import SalaryInput from '@components/inputs/salary-input'
import useSearchDispatcher from '@hooks/useSearchDispatcher'
import { serpFiltersUpdatedEvent } from '@lib/analytics-events'

import styles from './filters-menu.module.scss'

import type { JSX } from 'react'

type FiltersMenuProps = {
  isOpened: boolean
  onClose: () => void
  search: JobSearch
}

const FiltersMenu = ({ isOpened, onClose, search }: FiltersMenuProps): JSX.Element => {
  const [nextSearch, addParamsToSearch] = useSearchStore(
    useShallow((state) => [state.nextSearch, state.addParamsToSearch]),
  )
  const searchDispatcher = useSearchDispatcher()

  return (
    <ReactModal
      isOpen={isOpened}
      onRequestClose={onClose}
      closeTimeoutMS={200}
      shouldFocusAfterRender={true}
      overlayClassName={{
        base: styles.overlay,
        afterOpen: styles['overlay--open'],
        beforeClose: styles['overlay--close'],
      }}
      className={{ base: styles.wrapper, afterOpen: styles['wrapper--open'], beforeClose: styles['wrapper--close'] }}
      bodyOpenClassName={styles['scroll-lock']}
    >
      <div className={styles.head}>
        <CloseButton onClick={onClose} className={styles.close} />
        <p className={`h2 ${styles.title}`}>Refine your job search</p>
      </div>
      <form
        onSubmit={(e): void => {
          e.preventDefault()
          e.stopPropagation()
          serpFiltersUpdatedEvent(nextSearch)
          searchDispatcher({ page: 1 })
          onClose()
        }}
      >
        <Filter search={search} />
        <SalaryInput
          value={nextSearch.salary.min || 0}
          onChange={(value): void => addParamsToSearch({ salary: { min: value, type: 'PER_ANNUM' } })}
        />
        <Button type="submit" variant="yellow" size="lg" className={styles.submit}>
          Update
        </Button>
      </form>
    </ReactModal>
  )
}

export default FiltersMenu
